// extracted by mini-css-extract-plugin
export var intro = "intro-module--intro--4PCPO";
export var intro__second = "intro-module--intro__second--R_x4e";
export var intro__wrap = "intro-module--intro__wrap--tiZRI";
export var intro__section = "intro-module--intro__section--3bWfc";
export var intro__section__image = "intro-module--intro__section__image--3X5nP";
export var info__section__image__bg = "intro-module--info__section__image__bg--1__ch";
export var intro__section__image__bg = "intro-module--intro__section__image__bg--3qfIo";